import { bem } from '@socialive/common';
import PropTypes from 'prop-types';
import { InfoIcon } from '../../Icons';
import Tooltip from '../Tooltip';
import './formItemLabel.css';

/*
#tailwind
*/

function FormItemLabel({ label, htmlFor, toolTipText, className, ...other }) {
  return (
    <label htmlFor={htmlFor} {...other} className={bem`formItemLabel ${className}`}>
      {label}
      {toolTipText && (
        <Tooltip content={<span className="formItemLabel__tooltipText">{toolTipText}</span>}>
          <InfoIcon className="formItemLabel__tooltipIcon" />
        </Tooltip>
      )}
    </label>
  );
}

FormItemLabel.propTypes = {
  htmlFor: PropTypes.string,
  toolTipText: PropTypes.string,
  label: PropTypes.string,
  className: PropTypes.string,
};

FormItemLabel.defaultProps = {
  htmlFor: undefined,
  toolTipText: undefined,
  label: undefined,
  className: undefined,
};

export default FormItemLabel;
